export const LINE_FRIENDSHIP_COUSTOM_DATA_TAGE = {
	// ex : xxx_xxx
    FIRST_MGM: 'first_mgm',
    TOP_MGM: 'top_mgm'
};
